import React from 'react';
import { Checkbox } from 'material-ui';
import { useDispatch } from 'react-redux';
import { removeOutstandingItem } from '../outstanding/actions';
import {addAppointment} from '../../appointment/actions'
import { isDirectBillClient } from '../../../utils/utils';
import {directBillComment, notDirectBillComment} from '../../../service/constants'

const FooterListItem = ({item, isOutstanding}) => {
    const dispatch = useDispatch()
    const {id, firstName, lastName, type, date, counsellorRate, paymentSource} = item

    const removeItem = () => {
        dispatch(addAppointment(item))
        dispatch(removeOutstandingItem(id))
    }

    const isDirectBill = isDirectBillClient(paymentSource)

    return (
        <section className="invoice-line-item-container">
            {
                isOutstanding ? 
                    <Checkbox 
                    checked={true}
                    onClick={removeItem}
                    className="counsellor-checkbox"
                />
                : null 
            }
            
            <article className="invoice-line-item">
                <span className="flex-20">{`${firstName} ${lastName}`}</span>
                <span className="flex-20">{type}</span>
                <span className="flex-20" style={{flex: "12% 2"}}>{date}</span>
                <span className="flex-20" style={{flex: "10% 2"}}>${counsellorRate}</span>
                <span className="flex-20" style={{flex: "40% 2"}}>{isDirectBill ? directBillComment : notDirectBillComment}</span>
            </article>
        </section>
    );
};

export default FooterListItem;